import { useState } from "react";
import { toast } from "react-toastify";
import { NxtbnDrawer } from "..";
import useApi from "../../api";
import { NXForm } from "../common";
import AsyncSelectStyled from "../asyncSelectStyled";


function AddCustomerPromo({ isOpen, onClose, code, onRefresh }: {isOpen: boolean; onClose: () => void; code: string | null, onRefresh: () => void}) {
    const [selectedCustomers, setSelectedCustomers] = useState<any>([]);
    const api = useApi();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const payload = {
            promo_code: code,
            customer_ids: selectedCustomers
        }
        api.attachPromocodeEntity(payload).then((response) => {
            toast.success("Promocode attached to products successfully");
            onClose();
            onRefresh();
        }, (error) => {
            toast.error("Failed to attach promocode to products");
        })
    };


    const fetchOptions = async (inputValue: any) => {
        const params = {
          search: inputValue
        };
        const response = await api.getCustomerList(params) as any;  
        return response.results.map((item: any) => {
          const label = item.first_name && item.last_name 
            ? `${item.first_name} ${item.last_name} - ${item.username}` 
            : item.username;
            
          return { label, value: item.id, ...item };
        });
      };

    const handleCustomerChange = (selectedOption: any) => {
        const ids = selectedOption.map((item: any) => item.value);
        setSelectedCustomers(ids);
    };

    return (
        <NxtbnDrawer title={`Allow promocode for specific Customer only`} isOpen={isOpen} onClose={onClose}>
        <NXForm
            className="p-4"
            onSubmit={handleSubmit}
            title=""
            nonFieldError={{}}
        >
            <div className="mb-4">
            <label htmlFor="product-select" className="block mb-2 font-medium">Select Customer</label>
            <AsyncSelectStyled
                loadOptions={fetchOptions}
                onChange={handleCustomerChange}
                isClearable={true}
                isMulti={true}
                valueMax={500}
                // placeholder="Select a customer"
                addComponentName="customer"
                />
            </div>
            <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
            Save
            </button>
        </NXForm>
        </NxtbnDrawer>
    );
}

export default AddCustomerPromo;
